<div class="page-container">
  <div class="page-container__content">
    <h1>Messaging URL generator</h1>
    <form [formGroup]="newForm" (submit)="$event.preventDefault()">
      <p class="section-title">Required Params</p>

      <div class="fields">
        <label class="field">
          <span class="field__label">{{ fieldLabel('accountUID') }}</span>
          <input
            class="field__control"
            [class.field__control--invalid]="showError('accountUID')"
            formControlName="accountUID" />
          @if (showError('accountUID')) {
          <span class="field__error">{{ fieldError('accountUID') }}</span>
          }
        </label>
        <label class="field">
          <span class="field__label">{{ fieldLabel('subAccountUID') }}</span>
          <input
            class="field__control"
            [class.field__control--invalid]="showError('subAccountUID')"
            formControlName="subAccountUID" />
          @if (showError('subAccountUID')) {
          <span class="field__error">{{ fieldError('subAccountUID') }}</span>
          }
        </label>
        <label class="field">
          <span class="field__label">{{ fieldLabel('apiKey') }}</span>
          <input class="field__control" [class.field__control--invalid]="showError('apiKey')" formControlName="apiKey" />
          @if (showError('apiKey')) {
          <span class="field__error">{{ fieldError('apiKey') }}</span>
          }
        </label>
        <label class="field">
          <span class="field__label">{{ fieldLabel('secretKey') }}</span>
          <input
            class="field__control"
            [class.field__control--invalid]="showError('secretKey')"
            formControlName="secretKey" />
          @if (showError('secretKey')) {
          <span class="field__error">{{ fieldError('secretKey') }}</span>
          }
        </label>

        <div class="fields__row">
          <label class="field">
            <span class="field__label">{{ fieldLabel('displayName') }}</span>
            <input
              class="field__control"
              [class.field__control--invalid]="showError('displayName')"
              formControlName="displayName" />
            @if (showError('displayName')) {
            <span class="field__error">{{ fieldError('displayName') }}</span>
            }
          </label>
          <div class="field">
            <span class="field__label">{{ fieldLabel('phoneNumber') }}</span>
            <div class="phone-field" [class.field__control--invalid]="showError('phoneNumber')">
              <ngx-material-intl-tel-input
                [iconMakeCall]="false"
                [autoSelectCountry]="true"
                [autoSelectedCountry]="'us'"
                [autoIpLookup]="false"
                [enableSearch]="true"
                [required]="true"
                [fieldControl]="phoneControl"
                [preferredCountries]="['us']">
              </ngx-material-intl-tel-input>
            </div>
            @if (showError('phoneNumber')) {
            <span class="field__error">{{ fieldError('phoneNumber') }}</span>
            }
          </div>
        </div>

        <label class="field">
          <span class="field__label">{{ fieldLabel('routing') }}</span>
          <select
            class="field__control field__control--select"
            [class.field__control--invalid]="showError('routing')"
            formControlName="routing">
            <option value="SMS">SMS</option>
            <option value="WHATSAPP">WhatsApp</option>
          </select>
          @if (showError('routing')) {
          <span class="field__error">{{ fieldError('routing') }}</span>
          }
        </label>
      </div>

      <div class="separator"></div>
      <p class="section-title">Optional Params</p>

      <div class="fields">
        <div class="fields__row">
          <label class="field">
            <span class="field__label">{{ fieldLabel('ownerId') }}</span>
            <input class="field__control" formControlName="ownerId" />
          </label>
          <label class="field">
            <span class="field__label">{{ fieldLabel('ownerDisplayName') }}</span>
            <input class="field__control" formControlName="ownerDisplayName" />
          </label>
        </div>

        <div class="fields__row">
          <label class="field">
            <span class="field__label">{{ fieldLabel('startDate') }}</span>
            <input
              class="field__control"
              type="date"
              [value]="toDateInput(newForm.get('startDate')?.value)"
              (change)="setDate('startDate', $event)" />
          </label>
          <label class="field">
            <span class="field__label">{{ fieldLabel('endDate') }}</span>
            <input
              class="field__control"
              type="date"
              [value]="toDateInput(newForm.get('endDate')?.value)"
              (change)="setDate('endDate', $event)" />
          </label>
        </div>

        <label class="field">
          <span class="field__label">{{ fieldLabel('temporaryDisplayName') }}</span>
          <input class="field__control" formControlName="temporaryDisplayName" />
        </label>

        <label class="field">
          <span class="field__label">{{ fieldLabel('view') }}</span>
          <select class="field__control field__control--select" formControlName="view">
            <option value="">Select view</option>
            <option value="full">Full view</option>
            <option value="conversation">Conversation view</option>
            <option value="input">Input view</option>
          </select>
        </label>

        <div class="checks">
          @for (item of checkboxFields; track item.key) {
          <label class="check">
            <input type="checkbox" [formControlName]="item.key" />
            <span>{{ fieldLabel(item.key) }}</span>
          </label>
          }
        </div>

        <div class="tags">
          <div class="tags__header">
            <span class="tags__title">{{ fieldLabel('tags') }}</span>
            <button type="button" class="icon-btn" (click)="addTag('', 'tags')" aria-label="Add Tags">
              <mat-icon svgIcon="plus"></mat-icon>
            </button>
          </div>
          <div formArrayName="tags" class="tags__list">
            @for (tag of tagsForm('tags').controls; track $index) {
            <div class="tags__row">
              <input class="field__control" [formControlName]="$index" [attr.aria-label]="'Channel tag ' + ($index + 1)" />
              <button type="button" class="icon-btn" (click)="removeTag($index, 'tags')" aria-label="Remove tag">
                <mat-icon svgIcon="trash"></mat-icon>
              </button>
            </div>
            }
          </div>
        </div>

        <div class="tags">
          <div class="tags__header">
            <span class="tags__title">{{ fieldLabel('messagesTags') }}</span>
            <button type="button" class="icon-btn" (click)="addTag('', 'messagesTags')" aria-label="Add Messages Tags">
              <mat-icon svgIcon="plus"></mat-icon>
            </button>
          </div>
          <div formArrayName="messagesTags" class="tags__list">
            @for (tag of tagsForm('messagesTags').controls; track $index) {
            <div class="tags__row">
              <input class="field__control" [formControlName]="$index" [attr.aria-label]="'Message tag ' + ($index + 1)" />
              <button type="button" class="icon-btn" (click)="removeTag($index, 'messagesTags')" aria-label="Remove tag">
                <mat-icon svgIcon="trash"></mat-icon>
              </button>
            </div>
            }
          </div>
        </div>
      </div>

      <div class="separator"></div>
      <p class="section-title">Colors</p>

      <div class="colors">
        @for (field of colorFields; track field) {
        <label class="field">
          <span class="field__label">{{ fieldLabel(field) }}</span>
          <div class="color-row">
            <input class="field__control" [formControlName]="field" placeholder="#RRGGBB" />
            <input
              class="color-picker"
              type="color"
              [attr.aria-label]="fieldLabel(field) + ' picker'"
              [value]="colorPickerValue(field)"
              (input)="setColor(field, $event)" />
          </div>
        </label>
        }
      </div>

      <div class="separator"></div>

      <div class="actions">
        <button type="button" class="btn btn--primary" (click)="copyFormDataToClipboard()">
          <mat-icon svgIcon="copy"></mat-icon>
          Copy URL
        </button>
        <button type="button" class="btn btn--secondary" (click)="generateExternalURL()" [disabled]="isGenerating()">
          <mat-icon svgIcon="external-link"></mat-icon>
          {{ isGenerating() ? 'Generating…' : 'Generate external URL' }}
        </button>
      </div>

      @if (generateError()) {
      <p class="url-error">{{ generateError() }}</p>
      } @if (isGenerating()) {
      <p class="url-status">Loading url...</p>
      } @if (externalUrl()) {
      <div class="url">
        <a [href]="externalUrl()" target="_blank" rel="noreferrer">{{ externalUrl() }}</a>
      </div>
      }
    </form>
  </div>
</div>
